import { render, staticRenderFns } from "./v-chart.vue?vue&type=template&id=0ed91d08&scoped=true&"
import script from "./v-chart.vue?vue&type=script&lang=js&"
export * from "./v-chart.vue?vue&type=script&lang=js&"
import style0 from "./v-chart.vue?vue&type=style&index=0&id=0ed91d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed91d08",
  null
  
)

export default component.exports